import { Modal } from '@spo/storybook';
import { SpoModelsUpdateResponse, SpoUpdateSmResponse } from '@spo/types';
import { VpButton } from '@vtmn-play/react';
import { VtmnIcon } from '@vtmn/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ModalErrorType } from './MassEdit';

type MassEditErrorModalProps = {
  errorResponse: SpoUpdateSmResponse | SpoModelsUpdateResponse;
  type: ModalErrorType;
  refetch?: () => void;
};

export const MassEditErrorModal = ({
  errorResponse,
  type,
  refetch,
}: MassEditErrorModalProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const key = type.toLowerCase();

  const handleActionModal = () => {
    if (type === 'ERROR_API') {
      refetch && refetch();
    } else {
      navigate('/personal-offer/my-view');
    }
  };

  const footerModal = (
    <VpButton onClick={handleActionModal} variant="primary" shape="squared">
      {type === 'ERROR_API' ? t('retry') : t('back-to-personal-view')}
    </VpButton>
  );

  return (
    <Modal
      dataTestid="modal-mass-edit-error-summary"
      footer={footerModal}
      isOpen={Boolean(errorResponse)}
      title={t(`mass-edit.modal_${key}_error`)}
      ariaLabel="Mass Edit Error Modal"
      isClosable={false}
      closeOnClickOutside={false}
    >
      {type !== 'ERROR_API' && (
        <>
          <span className="modal_error_description">
            {t(`mass-edit.modal_${key}_error_description`)}
          </span>
          <ul data-testid={`modal-mass-edit-error-list-${key}`}>
            {Array.isArray(errorResponse) &&
              errorResponse?.map((item) => (
                <li key={item.id} data-testid={`item-error-${item.id}`}>
                  <strong>{item.id}</strong> : {item.detail}
                </li>
              ))}
          </ul>
        </>
      )}
      <p className="alert-message">
        {type !== 'ERROR_API' && <VtmnIcon value="alert-line" />}
        {t(`mass-edit.modal_${key}_error_message`)}
      </p>
    </Modal>
  );
};
